/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";

const manifest = {
  "acf/content-section": dynamic(() => import("../../../blocks/content/section.tsx"), "blocks/content/section.tsx"),
  "acf/holding-page-holding-page": dynamic(
    () => import("../../../blocks/holding-page/holding-page.tsx"),
    "blocks/holding-page/holding-page.tsx",
  ),
  ...core,
};

const info = {
  "acf/content-section": { "slug": "content/section", "flags": {} },
  "acf/holding-page-holding-page": { "slug": "holding-page/holding-page", "tags": [], "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
